import { useEffect, useState } from "react";

// Returns a copy of `value` that only updates after `delay` ms of no
// changes. Used to throttle search requests while typing.
export function useDebouncedValue<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
}
